<template>
  <div class='mainContainer'>
    <div class='tabs'>
      <div @click='typeFun(1)' class='left' :class='{ active: planType === 1 }'>装船管理</div>
      <div @click='typeFun(2)' class='right' :class='{ active: planType === 2 }'>卸船管理</div>
    </div>
    <div class='nav'>
      <!-- <div class="navContainer" style="width: 250px">
        <p style="width:100px;display:inline-block;text-align:right">供应商名称：</p>
        <el-input v-model="teamIpt" size="mini" style="width:150px" placeholder="请输入供应商名称"/>
      </div> -->
      <div class='navContainer' style='width: 250px'>
        <p style='width:100px;display:inline-block;text-align:right'>船舶名称：</p>
        <el-input v-model='licenseIpt' size='mini' style='width:150px' placeholder='请输入船舶名称' />
      </div>
      <div class='navContainer' style='width: 250px'>
        <p style='width:100px;display:inline-block;text-align:right'>航次：</p>
        <el-input v-model='voyageIpt' size='mini' style='width:150px' placeholder='请输入航次' />
      </div>
      <div class='navContainer' style='width: 250px'>
        <p style='width:100px;display:inline-block;text-align:right'>港口名称：</p>
        <el-input v-model='portName' size='mini' style='width:150px' placeholder='请输入作业港口' />
      </div>
      <div class='navContainer' style='width: 250px'>
        <p style='width:100px;display:inline-block;text-align:right'>批次号：</p>
        <el-input v-model='batchIpt' size='mini' style='width:150px' placeholder='请输入批次号' />
      </div>
      <div class='navContainer' style='width: 250px'>
        <p style='width:100px;display:inline-block;text-align:right'>运单编号：</p>
        <el-input v-model='waybill' size='mini' style='width:150px' placeholder='请输入运单编号' />
      </div>
      <div class='navContainer' style='width: 250px'>
        <p style='width:100px;display:inline-block;text-align:right'>车架号：</p>
        <el-input v-model='chassisIpt' size='mini' style='width:150px' placeholder='请输入车架号'
                  @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'chassisIpt')}"
        />
      </div>
      <div class='navContainer' style='width: 250px'>
        <p style='width:100px;display:inline-block;text-align:right'>装车类型：</p>
        <el-select v-model='shipTaskType' filterable size='mini' style='width:150px'
                   placeholder='请选择装车类型'>
          <el-option v-for='item in shipTaskList' :key='item.id' :label='item.name'
                     :value='item.id' />
        </el-select>
      </div>
      <div class='navContainer' style='width: 410px'>
        <p style='width:100px;display:inline-block;text-align:right'>作业时间：</p>
        <el-date-picker v-model="assignmentTime" :default-time="['00:00:00', '23:59:59']" value-format='yyyy-MM-dd HH:mm:ss' :clearable='false' :editable='false' type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size='mini'></el-date-picker>
        <!-- <el-date-picker v-model='startTime' size='mini' style='width:150px'
                        :clearable='false' :editable='false' value-format='yyyy-MM-dd HH:mm:ss'
                        @change='dateChange' type='date' placeholder='开始日期' />
        <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
        <el-date-picker v-model='endTime' size='mini' style='width:150px' v
                        :clearable='false' :editable='false' value-format='yyyy-MM-dd HH:mm:ss'
                        @change='dateChange' type='date' placeholder='结束日期' /> -->
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <!-- <el-button size="small" v-if="planType==1" style="height:30px" type="primary" @click="addBtn(0)">手动装车</el-button> -->
        <!-- <el-button size="small" v-else style="height:30px" type="primary" @click="addBtn(1)">手动卸车</el-button> -->
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <div class='tableContainerNav'>
          <!-- <span @click="downLoad">下载模板</span>
          <span style="cursor: pointer">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="uploadUrl"
                :auto-upload="true"
                :show-file-list="false"
                :data="uploadData"
                :on-success="planOnSuccess"
                :before-upload="beforeUpload"
              >
                <i class="el-icon-upload el-icon--right">批量导入</i>
              </el-upload>
          </span> -->
          <span @click='exportClick'>导出数据</span>
        </div>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column prop='taskPortName' label='港口名称' min-width='100' align='center' />
          <el-table-column prop='taskToolNum' label='船舶名称' min-width='110' align='center' />
          <el-table-column prop='voyageNumber' label='航次' min-width='100' align='center' />
          <el-table-column v-if='planType === 1' prop='taskExplain2' label='停放船舱' align='center' />
          <el-table-column label='作业类型' align='center'>
            <div slot-scope='scope'>{{ taskType(scope.row.taskType) }}</div>
          </el-table-column>
          <el-table-column prop='batchNumber' label='批次号' min-width='120' align='center' />
          <el-table-column prop='waybillNo' label='运单号' min-width='130' align='center' />
          <el-table-column prop='frameNumber' label='车架号' min-width='160' align='center' />
          <el-table-column prop='brandName' label='品牌' align='center' />
          <el-table-column prop='modelName' label='型号' align='center' />
          <el-table-column v-if='planType === 1' prop='driverName' label='司机' min-width='120' align='center' />
          <el-table-column prop='taskPeople' label='扫码人' min-width='120' align='center' />
          <el-table-column prop='taskDate' label='作业时间' min-width='140' align='center'>
            <template slot-scope='scope'>{{ getTime(scope.row.taskDate) }}</template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="165" align="center">
            <template slot-scope="scope">
              <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
              <el-button  size="mini" type="danger" @click="failureClick(getType(scope.row.type),scope.row.id)">{{ getType(scope.row.type) }}失败</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog title='详情' :visible.sync='detailDialogVisible' width='600px' center top='10vh'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>船舶名称：</span>
              <span>{{ detailData.shipName }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>船次：</span>
              <span>{{ detailData.voyageNumber }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>任务编号：</span>
              <span>{{ detailData.taskNumber }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>装卸类型：</span>
                <span>{{ getZxType(detailData.zxType) }}</span>
              </div>
              <div>
                <span class='span1'>任务类型：</span>
                <span>{{ getType(detailData.type) }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>批次号：</span>
                <span>{{ detailData.batchNumber }}</span>
              </div>
              <div>
                <span class='span1'>车架号：</span>
                <span>{{ detailData.frameNumber }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>委托车信息</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>批次号：</span>
                <span>{{ detailData.carCv ? detailData.carCv.batchNumber : '-' }}</span>
              </div>
              <div>
                <span class='span1'>车架号：</span>
                <span>{{ detailData.carCv ? detailData.carCv.frameNumber : '-' }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>品牌：</span>
                <span>{{ detailData.carCv ? detailData.carCv.brand : '-' }}</span>
              </div>
              <div>
                <span class='span1'>型号：</span>
                <span>{{ detailData.carCv ? detailData.carCv.model : '-' }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>配置：</span>
                <span>{{ detailData.carCv ? detailData.carCv.config : '-' }}</span>
              </div>
              <div>
                <span class='span1'>颜色：</span>
                <span>{{ detailData.carCv ? detailData.carCv.color : '-' }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>附件：</span>
              <span>{{ detailData.carCv ? detailData.carCv.fileName : '-' }}</span>
            </div>
          </div>
        </div>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>{{ detailData.zxType ? '卸车信息' : '装车车信息' }}</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>扫码人：</span>
              <span>{{ detailData.sweepName }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>{{ detailData.zxType ? '过驳时间' : '入库时间' }}：</span>
              <span>{{ detailData.actualEntruckingTime }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>{{ detailData.zxType ? '过驳地址' : '入库地址' }}：</span>
              <span>{{ detailData.entruckingPortName }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>{{ detailData.zxType ? '过驳船名' : '入库车位' }}：</span>
              <span>{{ detailData.zxType ? detailData.transferShipName : detailData.park }}</span>
            </div>
            <div class='baseInfoContentItem' v-if='detailData.zxType'>
              <span class='span1'>过驳船航次：</span>
              <span>{{ detailData.transferShipNumber }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <div class='imgContainer'>
                <el-image
                  v-for='(item,index) in detailData.img'
                  :key='index'
                  style='width: 100px; height: 100px;margin-right:10px; '
                  :src='baseImgUrl + item'
                  :preview-src-list='[baseImgUrl + item]'
                  fit='cover'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='750px' center
               :close-on-click-modal='false' top='10vh'>
      <div class='company'>
        <el-form :model='teamData' label-width='120px' :rules='rules' ref='ruleForm'>
          <div class='transport'>
            <div-border label='基础信息' style='padding: 20px 0'>
              <el-form-item v-if="dialogTitle==='手动卸车'" label='卸车类型：' prop='type'>
                <el-radio-group v-model='teamData.type' size='mini' @change='typeChange'>
                  <el-radio :label='0'>卸车</el-radio>
                  <el-radio :label='1'>过驳</el-radio>
                  <!-- <el-radio :label="2">转船</el-radio> -->
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="dialogTitle==='手动卸车'?'卸车港口：':'装车港口：'" prop='shippers'>
                <el-select v-model='teamData.shippers' filterable size='mini' style='width:85%'
                           value-key='id' placeholder='请选择港口' @change='entrustChange'>
                  <el-option v-for='item in shippersOption' :key='item.id'
                             :label='item.supplier_name' :value='item' />
                </el-select>
              </el-form-item>
              <el-form-item :label="dialogTitle==='手动卸车'?'卸车船舶：':'装车船舶：'" prop='entrust'>
                <el-select v-model='teamData.entrust' filterable size='mini' style='width:85%'
                           placeholder='请选择船舶' value-key='ship_id' @change='shipChange'>
                  <el-option v-for='item in entrustOption' :key='item.ship_id'
                             :label='item.ship_name' :value='item' />
                </el-select>
              </el-form-item>
              <el-form-item :label="dialogTitle==='手动卸车'?'卸船时间：':'装船时间：'" prop='loadDate'>
                <el-date-picker type='datetime' v-model='teamData.loadDate' style='width:85%'
                                size='mini' value-format='yyyy-MM-dd HH:mm:ss'
                                placeholder='请选择装船时间' />
              </el-form-item>
              <el-form-item v-if='teamData.type!=0' label='选择过驳船舶：' prop='shipment'>
                <el-select v-model='teamData.shipment' filterable size='mini' style='width:85%'
                           placeholder='请选择过驳船舶' value-key='id' @change='shipmentChange'>
                  <el-option v-for='item in shipmentOption' :key='item.ship_id'
                             :label='item.ship_name' :value='item.ship_id' />
                </el-select>
              </el-form-item>
            </div-border>
            <div-border :label="dialogTitle==='手动卸车'?'卸车车辆：':'装车车辆：'" style='padding: 10px'>
              <!-- <div class="tabs">
                <div @click="carTypeFun(1)" class="left" :class="{ active: teamData.carType === 1 }">委托车</div>
                <div @click="carTypeFun(2)" class="right" :class="{ active: teamData.carType === 2 }">批次号</div>
              </div> -->
              <div class='nav'>
                <div class='navContainer' style='width: 200px'>
                  <p style='width:60px;display:inline-block;text-align:right'>批次号：</p>
                  <el-input v-model='condition.batchNumber' size='mini' style='width:130px'
                            placeholder='请输入批次号' />
                </div>
                <div class='navContainer' style='width: 200px'>
                  <p style='width:60px;display:inline-block;text-align:right'>运单号：</p>
                  <el-input v-model='condition.waybillNo' size='mini' style='width:130px'
                            placeholder='请输入运单号' />
                </div>
                <!-- <div v-if="teamData.carType==1" class="navContainer" style="width: 200px">
                  <p style="width:60px;display:inline-block;text-align:right">车架号：</p>
                  <el-input v-model="condition.frameNumber" size="mini" style="width:130px" placeholder="请输入车架号"/>
                </div>
                <div v-if="teamData.carType==1" class="navContainer" style="width: 200px">
                  <p style="width:60px;display:inline-block;text-align:right">品牌：</p>
                  <el-input v-model="condition.brand" size="mini" style="width:130px" placeholder="请输入品牌"/>
                </div> -->
                <div class='navBtn'>
                  <el-button size='small' class='searchBtn' @click='carSearchBtn'>查询</el-button>
                  <el-button size='small' class='resetBtn' @click='carResetBtn'>重置</el-button>
                </div>
              </div>
              <el-table
                v-loading='carTableLoad'
                v-if='planType==2'
                :data='teamData.table'
                style='width: 100%;margin-top: 10px;'
                border
                @selection-change='handleSelectionChange'>
                <el-table-column type='selection' width='30' />
                <el-table-column prop='batchNumber' label='批次号' width='120px' align='center' />
                <el-table-column prop='waybillNo' label='运单号' width='150px' align='center' />
                <el-table-column prop='frameNumber' label='车架号' width='150px' align='center' />
                <el-table-column prop='brand' label='品牌' width='80px' align='center' />
                <el-table-column prop='model' label='型号' width='80px' align='center' />
                <el-table-column prop='weight' label='重量' width='50px' align='center' />
                <el-table-column prop='fileName' label='附件' align='center' />
                <el-table-column v-if="dialogTitle!=='手动卸车'" prop='deliveryPortName' label='交车港口'
                                 align='center' />
              </el-table>
              <el-table
                v-else
                :data='teamData.table'
                v-loading='carTableLoad'
                style='width: 100%' border stripe
                @expand-change='expandChange'
                :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'30px',background:'#E8E8E8'}"
                :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'30px'}">
                <el-table-column type='expand' width='30'>
                  <template slot-scope='scopeOut'>
                    <div style='width: 95%;margin-left: auto;' v-loading='scopeOut.row.loading'>
                      <!-- :ref="'children'+condition.page+'-'+scopeOut.row.index" -->
                      <el-table
                        :data='scopeOut.row.children'
                        border
                        max-height='300'
                        style='width: 100%'
                        :ref='scopeOut.row.batch_number+scopeOut.row.waybill_no'
                        @selection-change='handleCurrentChange($event,scopeOut.$index)'
                        :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'30px',background:'#E8E8E8'}"
                        :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'30px',}">
                        <el-table-column type='selection' align='center' width='50px' />
                        <el-table-column prop='frame_number' label='车架号' min-width='130'
                                         align='center'>
                          <template slot-scope='scope'>
                            <span v-if='scope.row.state==1'
                                  class='require'>{{ scope.row.frame_number }}</span>
                            <span v-else>{{ scope.row.frame_number }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop='brand_name' label='品牌' min-width='100'
                                         align='center' />
                        <el-table-column prop='model_name' label='型号' min-width='100'
                                         align='center' />
                        <el-table-column prop='weight' label='重量' align='center' />
                        <el-table-column prop='departure_port' label='交车港口' align='center' />
                      </el-table>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop='batch_number' label='批次号' align='center'>
                  <template slot-scope='scope'>
                    <span v-if='scope.row.state==1'
                          class='require'>{{ scope.row.batch_number }}</span>
                    <span v-else>{{ scope.row.batch_number }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop='waybill_no' label='运单号' align='center' />
                <el-table-column prop='count_car' label='数量' align='center' />
              </el-table>
              <div v-if='planType==1' class='paginationContainer' style='margin-top: 10px;'>
                <span>共{{ condition.total }}条</span>
                <el-pagination
                  background
                  :page-size='10'
                  layout='prev, pager, next,jumper'
                  :total='condition.total'
                  @size-change='conditionSizeChange'
                  @current-change='conditionCurrentChange'
                  @prev-click='conditionCurrentChange'
                  @next-click='conditionCurrentChange'
                />
              </div>
            </div-border>
            <!-- <div-border label="上传图片" is-need="true">
              <div class="imgUp">
                <div class="imgLength"><span>{{teamData.img.length}}/5</span></div>
                <el-upload
                  ref="uploads"
                  list-type="picture-card"
                  :action="uploadUrl"
                  :data="uploadData"
                  accept="image/png, image/jpeg, image/jpeg, image/bmp, image/gif"
                  :before-upload="beforeAvatarUpload"
                  :on-change="uploadChange"
                  :on-remove="handleRemove"
                  :on-progress="progress"
                  :on-success="success"
                  :file-list="teamData.img"
                  :limit="5"
                >
                  <div class="img-box">
                    <i class="el-icon-plus"/>
                    <span class="tips">点击上传照片</span>
                  </div>
                </el-upload>
              </div>
            </div-border> -->
          </div>
        </el-form>
        <div class='btnContainer'>
          <el-button class='searchBtn' :loading='imgIsUpload' @click='saveClick' size='small'>确定
          </el-button>
          <el-button class='resetBtn' @click='dialogClose' size='small'>取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import divBorder from '@/components/divBorder';
  import {
    dockInfoCvDetail,
    dockInfoCvFail,
    dockInfoCvPageList,
    loadingPageList,
    loadingChildPageList,
    shipDeployPublicSelectPort,
    dockInfoCvSelectPortShip,
    dockInfoCvSelectPorts,
    getUnloadList,
    dockInfoShipScanUnloading,
    dockInfoCvAddShipScanLoading,
    vehicleDeployCarGetStayLoadingByShip,
  } from '@/service/vehiclelog';
  import { baseImgUrl, baseUrl } from '@/config/env';
  import { formatDateTime } from '@/config/mUtils';
  import { getSessionStore } from '@/config/mUtils';
  import { getImport, getImportUrl } from '@/service/getIP';

  export default {
    components: {
      divBorder,
    },
    data() {
      let dateItem = new Date(new Date().getTime() - 144 * 60 * 60 * 1000);	//使用当天时间戳减去以前的时间毫秒（小时*分*秒*毫秒）
      let startDay = dateItem.getFullYear() + '-' +
        (dateItem.getMonth() + 1).toString()
          .padStart(2, '0') + '-' +
        dateItem.getDate()
          .toString()
          .padStart(2, '0');
      let endDay = new Date().getFullYear() + '-' +
        (new Date().getMonth() + 1).toString()
          .padStart(2, '0') + '-' +
        new Date().getDate()
          .toString()
          .padStart(2, '0');
      return {
        assignmentTime: ['', ''],
        downLoadVisible: false,  // 模板下载
        shipIpt: '',
        // voyageIpt: '',
        batchIpt: '',
        numberIpt: '',
        chassisIpt: '',
        waybill: '',
        startTime: startDay,
        endTime: endDay,
        // timeIpt:'',
        shipTaskType: '',
        portName: '',   // 作业港口名称
        // teamIpt:'',   // 供应商名称
        licenseIpt: '',   // 批次号
        voyageIpt: '', // 航次
        shipTaskList: [
          {
            id: '',
            name: '全部',
          },
          {
            id: 0,
            name: '正常作业',
          },
          {
            id: 1,
            name: '过驳',
          },
          {
            id: 2,
            name: '转船',
          },
        ],
        planType: 1,   // 装船/卸船管理控制字段
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        detailData: {
          img: [],
          carCv: {},
        },
        uploadUrl: '',
        uploadData: {
          file: '',
        },
        imgIsUpload: false,
        entrustOption: [],
        shippersOption: [],
        shipmentOption: [],
        dialogVisible: false,
        teamData: {
          entrust: '',
          shippers: '',
          shipment: '',
          loadDate: '',
          type: 0,
          carType: 1,
          table: [],
          selection: [],
          img: [],
        },
        baseImgUrl: baseImgUrl + '/',
        rules: {
          entrust: [
            {
              required: true,
              message: '请选择船舶',
              trigger: 'change',
            },
          ],
          loadDate: [{
            required: true,
            message: '请选择装船时间',
            trigger: 'change',
          }],
          shipment: [
            {
              required: true,
              message: '请选择过驳船舶',
              trigger: 'change',
            },
          ],
          shippers: [
            {
              required: true,
              message: '请选择港口',
              trigger: 'change',
            },
          ],
          time: [
            {
              required: true,
              message: `请选择时间`,
              trigger: 'change',
            },
          ],
          type: [
            {
              required: true,
              message: '请选择卸车类型',
              trigger: 'change',
            },
          ],
        },
        dialogTitle: '',
        condition: {   // 装车车辆 查询条件
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          brand: '',
          page: 1,
          size: 10,
          total: 0,
        },
        carTableLoad: false,   // 装车车辆 加载中
        selectData: [],  //装车车辆 —— 批次号 选中数据
      };
    },
    computed: {
      getHour() {
        return function(s2) {
          let s1 = new Date();
          s1 = formatDateTime(s1, 'yyyy-mm-dd hh:ii:ss');
          s1 = new Date(s1.replace(/-/g, '/'));
          s2 = new Date(s2.replace(/-/g, '/'));
          return Math.abs(s1.getTime() - s2.getTime()) / 3600000 <= 24;
        };
      },
      getType() {
        return function(state) {
          switch (state) {
            case 1:
              return '转驳';
            case 2:
              return '转船';
            case 3:
              return '入库';
          }
        };
      },
      getZxType() {
        return function(state) {
          switch (state) {
            case 0:
              return '装车';
            case 1:
              return '卸车';
          }
        };
      },
      getTime() {
        return function(time) {
          return formatDateTime(time, 'yyyy-mm-dd- hh:ii:ss');
        };
      },
      taskType() {
        return function(value) {
          switch (value) {
            case 1:
              return '装船';
            case 2:
              return '卸船';
          }
        };
      },
    },
    mounted() {
      this.init();
      // let token = getSessionStore('token')
      // this.uploadUrl = baseUrl + '/web/attachment/upload'
      // this.uploadUrl  = baseUrl +`/platform/transportScanOperation/batchLoading?access_token=${token}`
      this.uploadUrl = getImportUrl('/transportScanOperation/importExcelxlAddShipIn');
    },
    methods: {
      async init() {
     //   await this._dockInfoCvPageList();
      },
      // 装船管理/卸船管理
      typeFun(val) {
        this.resetBtn();
        this.planType = val;
        if (val == 1) {
          this.uploadUrl = getImportUrl('/transportScanOperation/importExcelxlAddShipIn');
        } else {
          this.uploadUrl = getImport('/platform/transportScanOperation/importExcelxlAddShipOut');
        }
        // console.log(this.uploadUrl);
      //  this._dockInfoCvPageList();
      },
      async _dockInfoCvPageList() {
        this.tableLoad = true;
        const res = await dockInfoCvPageList(
          {
            // shipName:this.shipIpt,
            // voyageNumber:this.voyageIpt,
            // taskNumber:this.numberIpt,
            // supplierName:this.teamIpt,      // 供应商名称
            taskToolNum: this.licenseIpt,    // 船舶名称
            voyageNumber: this.voyageIpt,  // 航次
            taskPortName: this.portName, // 作业港口名称
            batchNumber: this.batchIpt,
            waybillNo: this.waybill,
            frameNumber: this.chassisIpt,
            shipTaskType: this.shipTaskType,
            // startDate: this.startTime,
            startDate: this.assignmentTime[0],
            endDate: this.assignmentTime[1],
            // endDate: this.endTime,
            // startDate:this.timeIpt[0]?this.timeIpt[0]:'',
            // endDate:this.timeIpt[1]?this.timeIpt[1]:'',
            taskType: this.planType,
            rows: this.size,
            page: this.page,
          },
        );
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 结束时间
      dateChange(val) {
        if (this.endTime && this.startTime && (this.endTime <= this.startTime)) {
          if (val == this.endTime) this.endTime = '';
          if (val == this.startTime) this.startTime = '';
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      beforeAvatarUpload(file) {
        const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg'];
        const isJPG = TypeArr.includes(file.type);
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式');
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');
        return isJPG && isLt10M;
      },
      uploadChange(file, fileList) {
        this.teamData.img = fileList;
        if (Object.keys(file)
          .includes('response')) {
          if (file.response.status !== 0) {
            this.teamData.img.splice(this.teamData.img.indexOf(file), 1);
          }
        }
      },
      handleRemove(file, fileList) {
        this.teamData.img = fileList;
      },
      progress() {
        this.imgIsUpload = true;
      },
      success(res) {
        if (res.status !== 0) this.$message.error('该图片上传失败！');
        this.$message.success(res.message);
        this.imgIsUpload = false;
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._dockInfoCvPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._dockInfoCvPageList();
      },
      async detailClick(id) {
        this.detailDialogVisible = true;
        const res = await dockInfoCvDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = {
          ...res.data,
          img: res.data.imgUrl.split(','),
        };
      },
      handleSelectionChange(val) {
        this.teamData.selection = val;
      },
      // 新增 装车车辆 —— 委托车/批次号切换
      // carTypeFun(val){
      //   this.carResetBtn();
      //   this.teamData.carType = val;
      // },

      // 新增 装车车辆 一级 —— 查询
      async carSearchBtn() {
        //   batchNumber:'',
        //   waybillNo:'',
        //   frameNumber:'',
        //   brand:'',
        // },
        let obj = {
          type: 1,
          departurePlaceId: this.teamData.shippers.area_id,
          departurePortId: this.teamData.shippers.id,
          supplierId: this.teamData.entrust.supplier_id,
          page: this.condition.page,
          rows: this.condition.size,
        };
        this.carTableLoad = true;
        const res = await loadingPageList(obj);
        this.carTableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        // 给数据加上 index和children
        if (res.data.records.length > 0) {
          res.data.records.forEach((item, index) => {
            item.index = index;
            item.loading = true;
            item.children = [];
          });
        }
        this.teamData.table = res.data.records;
        this.condition.total = res.data.total;
      },
      // 新增 装车车辆 二级 —— 查询
      async carSearchChildBtn(row) {
        let obj = {
          type: 1,
          departurePlaceId: this.teamData.shippers.area_id,
          departurePortId: this.teamData.shippers.id,
          supplierId: this.teamData.entrust.supplier_id,
          batchNumber: row.batch_number,
          waybillNo: row.waybill_no,
        };
        const res = await loadingChildPageList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.teamData.table[row.index].children = res.data;
      },
      // 切换每页数据条数
      conditionSizeChange(sizes) {
        this.condition.size = sizes;
        this.carSearchBtn();
      },
      // 新增 装车车辆 —— 换页
      conditionCurrentChange(page) {
        this.condition.page = page;
        this.carSearchBtn();
      },
      // 新增 装车车辆 —— 重置
      carResetBtn() {
        this.condition.batchNumber = '';
        this.condition.waybillNo = '';
        this.condition.frameNumber = '';
        this.condition.brand = '';
      },
      // 展开行时是否查询 装车车辆 二级
      async judgeFn(row) {
        if (this.teamData.table[row.index].children.length <= 0) {
          // this.carSearchChildBtn(row);
          let obj = {
            type: 1,
            departurePlaceId: this.teamData.shippers.area_id,
            departurePortId: this.teamData.shippers.id,
            supplierId: this.teamData.entrust.supplier_id,
            batchNumber: row.batch_number,
            waybillNo: row.waybill_no,
          };
          const res = await loadingChildPageList(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.teamData.table[row.index].children = res.data;
        }
        return Promise.resolve;
      },
      // 新增 装车车辆 —— 批次号 展开行
      expandChange(row, val) {
        const isExpend = val.some(r => r.index === row.index);
        if (isExpend && val.length > 0) {
          this.teamData.table[row.index].loading = true;
          // 新增 装车车辆 二级 —— 查询
          // if(this.teamData.table[row.index].children.length <= 0){
          //   this.carSearchChildBtn(row);
          // }
          Promise.all([this.judgeFn(row)])
            .then(() => {
              if (this.selectData.length > 0) {
                let flg = false;
                this.selectData.forEach(item => {
                  if (item.id == row.batch_number + row.waybill_no) {
                    if (item.list.length > 0) {
                      item.list.forEach(tem => {
                        this.$nextTick(() => {
                          // this.$refs['children'+this.page+'-'+row.index].toggleRowSelection(
                          this.$refs[row.batch_number + row.waybill_no].toggleRowSelection(
                            this.teamData.table[row.index].children.find(tem1 => {
                              return tem.id == tem1.id;
                            })
                            , true);
                        });
                      });
                    }
                    return flg = true;
                  }
                });
                if (!flg) {
                  this.selectData.push({
                    id: row.batch_number + row.waybill_no,
                    list: [],
                  });
                }
              } else {
                this.selectData.push({
                  id: row.batch_number + row.waybill_no,
                  list: [],
                });
              }
              this.teamData.table[row.index].loading = false;
            });
        }
      },
      // 新增 装车车辆 —— 批次号 多选框
      handleCurrentChange(val, index) {
        if (val.length > 0) {
          this.selectData.filter(item => {
            if (item.id == val[0].batch_number + val[0].waybill_no) {
              item.list = val;
            }
          });
        }
      },


      // 手动装车/卸车 —— 确认
      saveClick() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            if (this.planType == 1) {
              this.teamData.selection = [];
              this.selectData.forEach(item => {
                this.teamData.selection = this.teamData.selection.concat(item.list);
              });
            }
            if (this.teamData.selection.length === 0) {
              return this.$message.warning('请至少选择一个委托车！');
            }
            this.imgIsUpload = true;
            let {
              shippers,
              entrust,
              loadDate,
              selection,
              type,
              shipment,
              table,
            } = this.teamData;
            const obj = {
              // imgUrl:str,
              // loadDate  装船时间
              taskDate: loadDate,
              taskToolId: entrust.ship_id,
              taskPositionId: shippers.id,
              carList: selection.map(item => {
                return {
                  id: item.id,
                };
              }),
            };
            let unload = {
              shipTaskType: type,
              taskDate: loadDate,
              taskPortId: shippers.id,
              taskToolId: entrust.ship_id,
              handoverShipId: shipment,
              carList: selection.length > 0 ? selection.map(item => {
                return { id: item.id };
              }) : [],
            };
            const res = this.dialogTitle === '手动卸车' ? await dockInfoShipScanUnloading(unload) : await dockInfoCvAddShipScanLoading(obj);
            this.imgIsUpload = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogVisible = false;
            await this._dockInfoCvPageList();
          } else {
            return false;
          }
        });
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
        this.carResetBtn();
        this.condition.page = 1;
        this.condition.size = 10;
        this.condition.total = 0;
      },
      failureClick(str, id) {
        this.$confirm(`确定${str}失败吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await dockInfoCvFail(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._dockInfoCvPageList();
          })
          .catch(() => {
          });
      },
      // 查询
      searchBtn() {
        const isAssignmentTime = Date.parse(this.assignmentTime[0]);
        if (!isAssignmentTime) return  this.$message.warning('请选择作业时间！');
        this.page = 1;
        this._dockInfoCvPageList();
      },
      // 重置
      resetBtn() {
        this.shipIpt = '';
        this.voyageIpt = '';
        this.batchIpt = '';
        this.numberIpt = '';
        this.waybill = '',
          this.chassisIpt = '';
        // this.timeIpt='';
        // this.startTime = '';
        this.assignmentTime = ['', ''];
        // this.endTime = '';
        this.shipTaskType = '',
          this.portName = '';     // 作业港口名称
        // this.teamIpt="";      // 供应商名称
        this.licenseIpt = '';   // 船舶名称
        this.voyageIpt = '';  // 航次名称
      },
      async addBtn(val) {
        this.dialogTitle = val ? '手动卸车' : '手动装车';
        this.dialogVisible = true;
        this.teamData = {
          entrust: '',
          shippers: '',
          shipment: '',
          loadDate: '',
          type: 0,
          carType: 1,
          table: [],
          selection: [],
          img: [],
        };
        let res = await shipDeployPublicSelectPort();
        if (res.status !== 0) return this.$message.error(res.message);
        this.shippersOption = res.data;
      },
      // 卸车类型改变
      typeChange() {
        this.teamData.shippers = '';
        this.teamData.entrust = '';
        this.teamData.shipment = '';
        this.entrustOption = [];
        this.shipmentOption = [];
        this.teamData.table = [];
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate();
        });
      },
      // 港口改变
      async entrustChange() {
        let { id } = this.teamData.shippers;
        if (this.dialogTitle === '手动卸车') {
          this.teamData.shipment = '';
          this.teamData.entrust = '';
          this.entrustOption = [];
          this.teamData.table = [];
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          let obj = {
            type: this.teamData.type,
            portId: id,
          };
          let res = await dockInfoCvSelectPorts(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.entrustOption = res.data.map(item => {
            return {
              ship_name: item.ship_name,
              ship_id: item.ship_id,
              disShipList: item.disShipList,
              supplier_id: item.supplier_id,
            };
          });
        } else {
          this.teamData.entrust = '';
          this.entrustOption = [];
          this.teamData.table = [];
          let res = await dockInfoCvSelectPortShip(id);
          if (res.status !== 0) return this.$message.error(res.message);
          this.entrustOption = res.data.map(item => {
            return {
              ship_name: item.ship_name,
              ship_id: item.ship_id,
              supplier_id: item.supplier_id,
            };
          });
        }
      },
      // 装车/卸车船舶改变
      async shipChange(value) {
        if (this.dialogTitle == '手动卸车') {
          this.teamData.shipment = '';
          this.$refs.ruleForm.clearValidate();
          if (this.entrustOption.length > 0) {
            this.entrustOption.forEach(item => {
              console.log(item, this.teamData.entrust.ship_id);
              if (item.ship_id == this.teamData.entrust.ship_id) {
                if (item.disShipList <= 0) return this.shipmentOption = [];
                this.shipmentOption = item.disShipList;
              }
            });
          }
          if (this.teamData.type == 0) {
            let obj = {
              type: this.teamData.type,
              portId: this.teamData.shippers.id,
              outShipId: this.teamData.entrust.ship_id,
            };
            let res = await getUnloadList(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.teamData.table = res.data;
          } else {
            this.teamData.table = [];
          }
        } else {
          // 装车
          this.carSearchBtn();
          // let res2 = await vehicleDeployCarGetStayLoadingByShip({
          //   // positionType:2,
          //   portId:this.teamData.shippers.id,
          //   shipId:value,
          //   // positionId:id,
          // })
          // if (res2.status !==0) return this.$message.error(res2.message)

          // this.teamData.table = res2.data
        }
      },
      // 过驳船舶改变
      async shipmentChange() {
        if (this.teamData.type != 0) {
          let obj = {
            type: this.teamData.type,
            portId: this.teamData.shippers.id,
            outShipId: this.teamData.entrust.ship_id,
            inShipId: this.teamData.shipment,
          };
          let res = await getUnloadList(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.teamData.table = res.data;
        }
      },
      // 模板下载
      downLoad() {
        if (this.planType == 1) {
          window.location.href = '/file/批量装船模板.xlsx';
        } else {
          window.location.href = '/file/批量卸船模板.xlsx';
        }
      },
      // 批量导入
      planOnSuccess(res) {
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.TableDatas = res.data;
        this._dockInfoCvPageList();

      },
      beforeUpload(file) {
        // console.log(file);
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData.file = file.name;
          this.tableLoad = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      exportClick() {
        // if (!this.startTime || !this.endTime || this.startTime == '' || this.endTime == '') {
        //   return this.$message.warning('请选择开始日期和结束日期！');
        // }
        if (!this.assignmentTime[0] || !this.assignmentTime[1] || this.assignmentTime[0] == '' || this.assignmentTime[1] == '') {
          return this.$message.warning('请选择开始日期和结束日期！');
        }
        // let token = getSessionStore('token');
        // let url = baseUrl + '/platform/transportScanOperation/shipExport';
        // // url += '?supplierName='+this.teamIpt;
        // url += '?voyageNumber=' + this.voyageIpt + '&taskToolNum=' + this.licenseIpt;
        // url += '&startDate=' + (this.startTime ? this.startTime : '');
        // url += '&endDate=' + (this.endTime ? this.endTime : '');
        // url += '&taskPortName=' + this.portName + '&batchNumber=' + this.batchIpt;
        // url += '&waybillNo=' + this.waybill + '&frameNumber=' + this.chassisIpt;
        // url += '&shipTaskType=' + this.shipTaskType + '&taskType=' + this.planType;
        // url += '&access_token=' + token;
        // window.location.href = url;
        window.exportExcelGet('/platform/transportScanOperation/shipExport',
          'voyageNumber=' + this.voyageIpt + '&taskToolNum=' + this.licenseIpt +

          // '&startDate=' + (this.startTime ? this.startTime : '') +
          '&startDate=' + (this.assignmentTime[0] ? this.assignmentTime[0] : '') +
          // '&endDate=' + (this.endTime ? this.endTime : '') +
          '&endDate=' + (this.assignmentTime[1] ? this.assignmentTime[1] : '') +

          '&taskPortName=' + this.portName + '&batchNumber=' + this.batchIpt +
          '&waybillNo=' + this.waybill + '&frameNumber=' + this.chassisIpt +
          '&shipTaskType=' + this.shipTaskType + '&taskType=' + this.planType
        )
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'chassisIpt':
            this.chassisIpt = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
    },
  };
</script>

<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .img-box {
      position: relative;
      width: 150px;
      height: 100px;

      img {
        width: 150px;
        height: 100px;
      }

      .tips {
        position: absolute;
        display: none;
      }

      &:hover .tips {
        display: block;
        position: absolute;
        //bottom:0;
        top: 0;
        left: 0;
        color: #FFF;
        width: 146px;
        z-index: 10;
        height: 148px;
        background: #000;
        opacity: 0.6;
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 245px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainerNav {
        font-size: 16px;
        text-decoration: underline;
      }

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 25px;
        width: 100%;

        &Nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 70vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .addressItem {
              font-size: 12px;
              color: rgba(153, 153, 153, 1);
              margin-bottom: 10px;
              margin-left: 70px;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }
    }

    .company {
      width: 100%;
      padding: 20px 10px 10px 10px;
      max-height: 70vh;
      overflow: auto;

      .imgUp {
        display: flex;
        flex-direction: column;
        margin: 10px 0;

        .imgLength {
          display: flex;
          align-items: center;
          width: 100%;

          span {
            margin-left: auto;
            color: rgb(183, 183, 183);
            font-size: 16px;
          }
        }
      }

      .transport {
        width: 100%;
        position: relative;
        padding: 0 10px;
        margin-bottom: 20px;

        ::v-deep {
          .el-checkbox {
            margin-left: 8px;
          }
        }

        &Title {
          margin-bottom: 0;
          position: absolute;
          top: -21px;
          z-index: 999;
          background-color: #fff;
          left: 20px;
          padding-right: 10px;
          color: rgb(51, 84, 131);
          font-size: 15px;
          font-weight: 700;

          ::v-deep {
            .el-form-item__label {
              color: rgb(51, 84, 131);
              font-size: 15px;
            }
          }
        }
      }

      .productTable {
        margin-top: 15px;

        &Nav {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;

          &Left {
            display: flex;
            align-items: center;

            ::v-deep {
              .el-input--mini .el-input__inner {
                height: 22px;
              }

              .el-input__icon {
                height: 120%;
              }
            }

            span {
              color: #606266;
              font-weight: 700
            }
          }

          &Right {
            text-decoration: underline;
            color: rgb(51, 136, 255);
          }
        }

        ::v-deep {
          .el-checkbox {
            margin-left: 8px;
          }

          .el-input--mini .el-input__inner {
            width: 100%;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }

          .el-table td, .el-table th {
            padding: 0;
          }
        }

        .tableAddBtnContainer {
          border: 1px solid #EBEEF5;;
          border-top-style: none;
          width: 100%;
          height: 35px;
          display: flex;
          align-items: center;
          padding-left: 15px;

          .AddContainer {
            display: flex;
            align-items: center;

            &:hover {
              cursor: pointer;
            }
          }

          img {
            object-fit: cover;
            margin-right: 5px;
          }

          p {
            font-size: 13px;
            color: #F59A23;
            font-family: 'Arial Normal', 'Arial', sans-serif;
          }
        }
      }

      .update {
        font-size: 14px;
        color: rgba(51, 136, 255, 1);
        text-decoration: underline;
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item {
          margin-bottom: 12px;
        }

        .el-form-item__content {
          position: relative;
        }

        .el-checkbox {
          margin-left: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        .el-table td, .el-table th {
          padding: 0;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 5px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-table .ui-warning-row {
      background: #DDD !important;
    }

    .el-table .ui-warning-row .cell {
      color: red;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .paginationContainer {
    margin-right: auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .require::before {
    content: '•';
    color: red;
  }
</style>
